// @flow
import * as React from 'react';
import PropTypes from 'prop-types';

type InjectedProps = {|
  hideAllToasts: void | (() => mixed),
  showToast: void | ((Toast: React.ComponentType<any>) => mixed),
|};

export default function withShowToast<Props: {}>(
  Subject: React.AbstractComponent<Props>,
): React.AbstractComponent<$Diff<Props, InjectedProps>> {
  return class Toaster extends React.Component<$Diff<Props, InjectedProps>> {
    // $FlowFixMe: new errors found from flow 0.96 upgrade
    static displayName = `WithShowToast(${Subject.displayName || Subject.name})`;
    static contextTypes = {
      showToast: PropTypes.func,
      hideAllToasts: PropTypes.func,
    };

    showToast = (Toast: React.ComponentType<any>) => {
      if (this.context.showToast) {
        this.context.showToast(Toast);
      }
    };

    hideAllToasts = () => {
      if (this.context.hideAllToasts) {
        this.context.hideAllToasts();
      }
    };

    render() {
      return (
        <Subject {...this.props} hideAllToasts={this.hideAllToasts} showToast={this.showToast} />
      );
    }
  };
}
